import { React, useEffect, useState } from "react";
import ToolsTab from "../../../components/toolsTab";
import ToolsInfoSection from "../../../components/toolsInfoSection";
import ico_handy_orange from "../../../assets/icons/ico_handy_orange.svg";
import ico_huellas_green from "../../../assets/icons/ico_huellas_green.svg";
import ico_caso_exito from "../../../assets/icons/ico_caso_exito.svg";
import VideoBanner from "../../../components/videoBanner";
import img_escarabajos_trampa_pequena from "../../../assets/images/img_escarabajos_trampa_pequena.png";
import img_trampa_pequena from "../../../assets/images/img_trampa_pequena.svg";
import GoToPage from "../../../components/goToPage";
import ToolsActivityButton from "../../../components/toolsActivityButton";
const SmallFallTrapScreen = ({ handle }) => {
  const [width, setWidth] = useState(window.innerWidth);
  const arenoso = "_xd45qDajX4";

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [width]);

  useEffect(() => {
    handle(false);
    return () => handle(true);
  }, [handle]);

  return (
    <div className="w-full bg-[#002E0F] h-full overflow-hidden">
       {width > 1279 ? (
       <div>
<div className="w-full lg:h-[1080px]  absolute">
        <VideoBanner idVideo={arenoso}></VideoBanner>
      </div>
      <div className="w-full mx-auto text-white relative ">
        <div className="absolute right-0 mt-[28rem] ">
          <img
          
            src={img_escarabajos_trampa_pequena}
            className="lg:w-[67rem] md:w-[40rem] sm:w-[20rem] w-[20rem] 2xl:visible xl:invisible lg:invisible md:invisible sm:visible visible"
          ></img>
        </div>
        <div className="justify-center text-black h-fit text-left pt-[14rem] relative lg:pl-[8rem] md:pl-[3rem] sm:pl-[3rem] pl-[3rem]">
         <GoToPage
                page="/herramientas"
                side="left"
                name="Atrás"
                fontSizeXL="xl:text-xl"
                fontSizeL="lg:text-lg"
                fontSizeM="md:text-lg"
                fontSizeS="sm:text-base"
                fontSize="text-base"
                textType="font-bold"
                textColor="text-white"
                borderType="border-b-2"
                borderColor="border-white"
                iconSize="h-5"
                iconColor="invert"
                iconMargin="mr-5"
              ></GoToPage>
        </div>
        <div className="grid mb-52 relative lg:pl-32 md:pl-20 sm:pl-10 pl-10 2xl:pr-0 xl:pr-[15rem] lg:pr-[20rem] md:pr-[5rem] sm:pr-[5rem] pr-[5rem] mr-80 2xl:grid-cols-5 xl:grid-cols-1 lg:grid:cols-1 md:grid-cols-1 sm:grid-cols-1 grid-cols-1 2xl:pb-[10rem] xl:pb-[70rem] lg:pb-[70rem] md:pb-[90rem] sm:pb-[90rem] pb-[90rem] min-w-[10rem] pt-10 w-full  ">
          <div className="text-left h-fit col-span-2 text-black lg:mr-10 sm:bottom-0 bg-white w-full z-10 relative">
            <ToolsInfoSection
              firstIcon={ico_handy_orange}
              secondIcon={ico_huellas_green}
              tag="Escarabajos Estercoleros"
              title={
                <h1 className="lg:text-5xl md:text-2xl sm:text-2xl text-2xl lg:px-10 md:px-0 sm:px-0 px-0 lg:text-left md:text-center sm:text-center text-center font-bold  my-10 ">
                  Trampa de <br /> caída pequeña
                </h1>
              }
              text={
                <div>
                  <p className="lg:px-10 md:px-0 sm:px-0 px-0 lg:text-xl md:text-xl sm:text-base text-base pb-5">
                    Las <b>trampas de caída pequeña</b> se elaboran con vasos
                    plásticos,
                    lenguas de madera con una muestra de estiércol de animales
                    (por
                   ejemplo, cerdo o vaca) y alcohol. Se considera que el
                    inventario de estos insectos es{" "}
                    <b>económico, práctico y estándar</b>.
                  </p>
                  <p className="lg:px-10 md:px-0 sm:px-0 px-0 lg:text-xl md:text-xl sm:text-base text-base pb-5">
                  Con esta técnica, los escarabajos se ven atraídos por el sebo y al acercarse al vaso, caen en el alcohol. Este último ayuda a preservarlos hasta que se recolecten
                  </p>
                </div>
              }
            ></ToolsInfoSection>
            <img loading="lazy" src={img_trampa_pequena} className=" px-20 w-full mb-52"></img>
          </div>

          <div className="relative col-span-3 2xl:mt-[11rem] xl:mt-[0rem] lg:mt-[0rem] md:mt-[0rem] sm:mt-[0rem] mt-[0rem]  items-center">
                <div className=" grid relative gap-0">
                  <div className="h-full relative">
                <img
                
                  src=""
                  className="w-[50rem] mt-[3.5rem] right-0 absolute z-0 top-0"
                ></img>
                <div className="h-44 w-full bg-[#ffb223] relative 2xl:mt-[25.6rem] xl:mt-0 md:mt-0 sm:mt-0 mt-0 pl-20">
                  <div className="grid grid-cols-2 grid-rows-1 relative text-white">
                    <div className="inline-flex items-center py-5 ml-10">
                      <img loading="lazy" src={ico_caso_exito}></img>
                      <label className="ml-5 text-2xl font-bold">
                        Caso <br /> de éxito
                      </label>
                    </div>
                    <p className="py-16 text-lg">
                      Estudios de herpetofauna en Puro Verde <br /> Paraíso
                      Forestal.
                    </p>
                  </div>
                </div>
              </div>
              <div className="relative w-full h-full items-center  text-white bg-[#002E0F] pr-10 pt-5">
                <ToolsTab
                firstTitle="Sistemas productivos y naturales"
                secondTitle="Resultados y beneficios"
                  firstTab={
                    <p className="lg:text-xl md:text-base sm:text-sm text-sm mb-5">
                      Con los escarabajos coprófagos es fácil realizar estudios
                      para monitorear distintos tipos de paisaje como áreas de
                      cultivo, bosques secundarios, bosques maduros, pastizales.
                      Además, se pueden realizar comparaciones entre las
                      distintas especies y sus funciones ecológicas por sitio,
                      así como monitoreos en las temporadas seca y lluviosa y en
                      las temporadas de veranos cortos.
                    </p>
                  }
                  secondTab={
                    <div>
                      <p className="lg:text-xl md:text-base sm:text-sm text-sm mb-5">
                        Evidencia de la diversidad de especies y sus relaciones
                        complejas.
                      </p>
                      <p className="lg:text-xl md:text-base sm:text-sm text-sm mb-5">
                        El monitoreo periódico puede revelar si las prácticas
                        sostenibles o las medidas de conservación implementadas
                        por las empresas tienen impacto real en el aumento de la
                        biodiversidad.
                      </p>
                      <p className="lg:text-xl md:text-base sm:text-sm text-sm mb-5">
                        Se puede evidenciar que la empresa resguarda ambientes y
                        especies valiosas como endémicas o amenazadas.
                      </p>
                    </div>
                  }
                ></ToolsTab>
              </div>
            </div>
          </div>
        </div>
      </div>
       </div>
       ):(
       <div>

<div className="w-full absolute ">
            <VideoBanner idVideo={arenoso}></VideoBanner>
            <div className=" absolute right-0 bottom-0 ">
              <img
              
                src={img_escarabajos_trampa_pequena}
                className="lg:w-[45rem] md:w-[30rem] sm:w-[22rem] w-[22rem]"
              ></img>
            </div>
          </div>

          <div className="grid grid-cols-1  2xl:px-52  lg:px-30 md:px-10 sm:px-14 px-10 pb-[40rem]">
            <div className="justify-center text-black h-fit text-left lg:mt-[25rem] md:mt-[15rem] sm:mt-[7rem] mt-[7rem] relative ">
             <GoToPage
                page="/herramientas"
                side="left"
                name="Atrás"
                fontSizeXL="xl:text-xl"
                fontSizeL="lg:text-lg"
                fontSizeM="md:text-lg"
                fontSizeS="sm:text-base"
                fontSize="text-base"
                textType="font-bold"
                textColor="text-white"
                borderType="border-b-2"
                borderColor="border-white"
                iconSize="h-5"
                iconColor="invert"
                iconMargin="mr-5"
              ></GoToPage>
            </div>

            <div className=" h-fit text-black  bg-white w-full z-10 relative bottom-0  mt-[4rem]  ">
              <div className="lg:h-44 md:h-40 sm:h-32 h-32 w-full bg-[#F77E0B] relative">
                <div className="grid grid-cols-2 grid-rows-1 relative text-white   ">
                  <div className=" inline-flex justify-center w-full absolute lg:py-5 md:py-5 sm:py-2 py-2 lg:px-10 md:px-5 sm:px-5 px-5">
                    <div className="w-fit  mr-2">
                      <img
                      
                        src={ico_caso_exito}
                        className="lg:w-20 md:w-14 sm:w-14 w-14"
                      ></img>
                    </div>
                    <div className="">
                      <div className="inline-flex items-center  ">
                        <label className=" lg:text-2xl md:text-xl sm:text-lg text-lg font-bold">
                          Macroinvertebrados
                        </label>
                      </div>
                      <div className=" w-full">
                        <p className="lg:text-lg md:text-base sm:text-xs text-xs">
                          Este grupo está compuesto por animales de{" "}
                          distintos grupos taxonómicos, incluyendo{" "}
                          insectos, arañas, cangrejos, conchas y{" "}
                          camarones, entre otros.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <ToolsInfoSection
              firstIcon={ico_handy_orange}
              secondIcon={ico_huellas_green}
              tag="Escarabajos Estercoleros"
              title={
                <h1 className="lg:text-5xl md:text-2xl sm:text-2xl text-2xl lg:px-10 md:px-0 sm:px-0 px-0 lg:text-left md:text-center sm:text-center text-center font-bold  my-10 ">
                  Trampa de <br /> caída pequeña
                </h1>
              }
              text={
                <div>
                  <p className="lg:px-10 md:px-0 sm:px-0 px-0 lg:text-xl md:text-xl sm:text-base text-base pb-5">
                    Las <b>trampas de caída pequeña</b> se elaboran con vasos
                    plásticos,
                    lenguas de madera con una muestra de estiércol de animales
                    (por
                   ejemplo, cerdo o vaca) y alcohol. Se considera que el
                    inventario de estos insectos es{" "}
                    <b>económico, práctico y estándar</b>.
                  </p>
                  <p className="lg:px-10 md:px-0 sm:px-0 px-0 lg:text-xl md:text-xl sm:text-base text-base pb-5">
                  Con esta técnica, los escarabajos se ven atraídos por el sebo y al acercarse al vaso, caen en el alcohol. Este último ayuda a preservarlos hasta que se recolecten
                  </p>
                </div>
              }
            ></ToolsInfoSection>
            <img loading="lazy" src={img_trampa_pequena} className=" px-20 w-full mb-52"></img>
            </div>
            <div className="relative w-full h-full items-center lg:mt-32 md:mt-10 sm:mt-5 mt-5  text-white bg-[#002E0F]">
            <ToolsTab
            firstTitle="Sistemas productivos y naturales"
            secondTitle="Resultados y beneficios"
                  firstTab={
                    <p className="lg:px-10 md:px-0 sm:px-0 px-0 lg:text-xl md:text-base sm:text-sm text-sm pb-5">
                      Con los escarabajos coprófagos es fácil realizar estudios
                      para monitorear distintos tipos de paisaje como áreas de
                      cultivo, bosques secundarios, bosques maduros, pastizales.
                      Además, se pueden realizar comparaciones entre las
                      distintas especies y sus funciones ecológicas por sitio,
                      así como monitoreos en las temporadas seca y lluviosa y en
                      las temporadas de veranos cortos.
                    </p>
                  }
                  secondTab={
                    <div>
                      <p className="lg:px-10 md:px-0 sm:px-0 px-0 lg:text-xl md:text-base sm:text-sm text-sm pb-5">
                        Evidencia de la diversidad de especies y sus relaciones
                        complejas.
                      </p>
                      <p className="lg:px-10 md:px-0 sm:px-0 px-0 lg:text-xl md:text-base sm:text-sm text-sm pb-5">
                        El monitoreo periódico puede revelar si las prácticas
                        sostenibles o las medidas de conservación implementadas
                        por las empresas tienen impacto real en el aumento de la
                        biodiversidad.
                      </p>
                      <p className="lg:px-10 md:px-0 sm:px-0 px-0 lg:text-xl md:text-base sm:text-sm text-sm pb-5">
                        Se puede evidenciar que la empresa resguarda ambientes y
                        especies valiosas como endémicas o amenazadas.
                      </p>
                    </div>
                  }
                ></ToolsTab>
            </div>
          </div>

       </div>
       )}
      
    </div>
  );
};

export default SmallFallTrapScreen;
